import { RootApp } from "./routers";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import i18n from "./assets/translate";
import { ConfigProvider } from "antd";
function App() {
  return (
    <main className="main-application">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#F66524 !important",
          },
        }}
      >
        <RootApp />
      </ConfigProvider>
    </main>
  );
}

export default App;
